var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228.001,
    height: 215.733,
    viewBox: "0 0 228.001 215.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reward",
    transform: "translate(0 -13.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48981",
    "data-name": "Path 48981",
    d: "M157.206,219.555a50.792,50.792,0,0,0-7.757,2.681,61.556,61.556,0,0,1,12.629,17.372l.165.343-12.015,5.842-.165-.338A48.209,48.209,0,0,0,137.63,229.57l0,0a48.18,48.18,0,0,0-12.429,15.88l-.165.338-12.015-5.843.165-.343a61.557,61.557,0,0,1,12.629-17.372,50.788,50.788,0,0,0-7.757-2.681A100.608,100.608,0,0,1,80.919,43.135L89.2,53.622a87.245,87.245,0,0,0,32.187,152.992,63.84,63.84,0,0,1,16.241,6.675s10.474-5.188,16.249-6.675A87.245,87.245,0,0,0,186.062,53.622l8.278-10.487a100.608,100.608,0,0,1-37.135,176.42Z",
    transform: "translate(-23.63 -16.286)",
    fill: "#ffc648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48982",
    "data-name": "Path 48982",
    d: "M275.57,219.555a50.793,50.793,0,0,0-7.757,2.681,61.556,61.556,0,0,1,12.629,17.372l.165.343-12.015,5.842-.165-.338a48.209,48.209,0,0,0-12.433-15.884l0,0V213.289s10.474-5.188,16.249-6.675A87.245,87.245,0,0,0,304.427,53.622l8.278-10.487a100.608,100.608,0,0,1-37.135,176.42Z",
    transform: "translate(-141.994 -16.286)",
    fill: "#fc9d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29374",
    "data-name": "Group 29374",
    transform: "translate(44.585 176.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48983",
    "data-name": "Path 48983",
    d: "M125.536,414.781a17.955,17.955,0,0,1-13.463-6.035l-11.952-13.453,13.453-11.952a18.016,18.016,0,0,1,25.406,1.5L150.932,398.3l-13.453,11.952A17.924,17.924,0,0,1,125.536,414.781Z",
    transform: "translate(-100.121 -378.806)",
    fill: "#fff066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29375",
    "data-name": "Group 29375",
    transform: "translate(13.363 141.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48984",
    "data-name": "Path 48984",
    d: "M50.985,337.671A18.008,18.008,0,0,1,33.338,323l-3.329-17.685,17.685-3.33a18.017,18.017,0,0,1,21.014,14.356l3.329,17.686-17.686,3.329A18.181,18.181,0,0,1,50.985,337.671Z",
    transform: "translate(-30.009 -301.672)",
    fill: "#fff066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29376",
    "data-name": "Group 29376",
    transform: "translate(0 91.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48985",
    "data-name": "Path 48985",
    d: "M30.843,232.705l-17.407-4.567A18,18,0,0,1,.6,206.165l4.567-17.406,17.406,4.567A18.017,18.017,0,0,1,35.409,215.3Z",
    transform: "translate(0 -188.759)",
    fill: "#fff066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29377",
    "data-name": "Group 29377",
    transform: "translate(10.327 38.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48986",
    "data-name": "Path 48986",
    d: "M40.008,120.8,27.887,107.5a18,18,0,0,1,1.18-25.422l13.3-12.121,12.121,13.3a18,18,0,0,1-1.18,25.422Z",
    transform: "translate(-23.192 -69.957)",
    fill: "#fff066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29378",
    "data-name": "Group 29378",
    transform: "translate(45.08 13.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48987",
    "data-name": "Path 48987",
    d: "M121.038,49.769a18.325,18.325,0,0,1-1.908-.1l-17.9-1.873,1.873-17.9a18,18,0,0,1,19.771-16.025l17.9,1.873-1.873,17.9a18,18,0,0,1-17.864,16.124Z",
    transform: "translate(-101.233 -13.774)",
    fill: "#fff066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29379",
    "data-name": "Group 29379",
    transform: "translate(132.604 176.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48988",
    "data-name": "Path 48988",
    d: "M311.231,410.247,297.778,398.3l11.952-13.454a18.016,18.016,0,0,1,25.405-1.5l13.453,11.952-11.952,13.453a18.016,18.016,0,0,1-25.405,1.5Z",
    transform: "translate(-297.778 -378.806)",
    fill: "#ffc648"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29380",
    "data-name": "Group 29380",
    transform: "translate(172.608 141.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48989",
    "data-name": "Path 48989",
    d: "M405.3,337.356l-17.686-3.329,3.329-17.686a18.018,18.018,0,0,1,21.014-14.356l17.685,3.33L426.31,323a18.009,18.009,0,0,1-17.647,14.672A18.26,18.26,0,0,1,405.3,337.356Z",
    transform: "translate(-387.611 -301.673)",
    fill: "#ffc648"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29381",
    "data-name": "Group 29381",
    transform: "translate(191.999 91.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48990",
    "data-name": "Path 48990",
    d: "M431.748,215.3a18.016,18.016,0,0,1,12.84-21.974l17.406-4.567,4.567,17.406a18,18,0,0,1-12.84,21.973L436.314,232.7Z",
    transform: "translate(-431.156 -188.758)",
    fill: "#ffc648"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29382",
    "data-name": "Group 29382",
    transform: "translate(181.68 38.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48991",
    "data-name": "Path 48991",
    d: "M413.859,108.68a18,18,0,0,1-1.18-25.422l12.121-13.3,13.3,12.121a18,18,0,0,1,1.18,25.422l-12.121,13.3Z",
    transform: "translate(-407.983 -69.956)",
    fill: "#ffc648"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29383",
    "data-name": "Group 29383",
    transform: "translate(143.377 13.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48992",
    "data-name": "Path 48992",
    d: "M330.41,45.751a17.877,17.877,0,0,1-6.567-12.107l-1.873-17.9,17.9-1.873A18,18,0,0,1,359.639,29.9l1.873,17.9-17.9,1.873a18.325,18.325,0,0,1-1.908.1A17.859,17.859,0,0,1,330.41,45.751Z",
    transform: "translate(-321.97 -13.774)",
    fill: "#ffc648"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48993",
    "data-name": "Path 48993",
    d: "M235.408,185.364a60.534,60.534,0,0,1-82.659,22.159L124.4,139.987A60.533,60.533,0,0,1,183,94.605Z",
    transform: "translate(-69.003 -44.836)",
    fill: "#fff066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48994",
    "data-name": "Path 48994",
    d: "M308.4,185.364a60.472,60.472,0,0,1-52.409,30.255V94.605Z",
    transform: "translate(-141.994 -44.836)",
    fill: "#ffc648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48995",
    "data-name": "Path 48995",
    d: "M165.5,211.638v15.127l-15.127,15.127v22.159a60.6,60.6,0,0,1-28.349-67.536h11.623l16.726,15.123Z",
    transform: "translate(-66.629 -101.364)",
    fill: "#ffc648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48996",
    "data-name": "Path 48996",
    d: "M316.495,155.11a60.23,60.23,0,0,1-8.1,30.255h-7.023l-15.127-15.127H271.122v-30.25L255.99,124.86V94.605A60.5,60.5,0,0,1,316.495,155.11Z",
    transform: "translate(-141.994 -44.836)",
    fill: "#fc9d56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.e991651e62ca7432607bdd325c62dd1c.svg";
export { ForwardRef as ReactComponent };